import { View } from 'react-native';

import Touchable from '../Touchable';
import S, { styles } from './styles';

export default props => {
  const {
    navigationState,
    route,
    activeColor,
    inactiveColor,
    labelStyle,
    tabContainerStyle,
    style,
    ...rest
  } = props;
  const tabIndex = navigationState.routes.indexOf(route);
  const isFocused = navigationState.index === tabIndex;

  return (
    <Touchable {...rest} style={tabContainerStyle}>
      <View style={[styles.Wrapper, style]}>
        <S.Text
          isFocused={isFocused}
          activeColor={activeColor}
          inactiveColor={inactiveColor}
          style={labelStyle}
        >
          {route.title}
        </S.Text>
      </View>
    </Touchable>
  );
};
